// @flow

import * as React from 'react';
import { useEffect } from 'react';

type AdInfo = {
  adsId: string,
  sizes: any[],
  divId: string,
};

type Props = {
  desktop: AdInfo,
  mobile: AdInfo,
  divId: string,
  onSlotRenderEnded?: (event: any) => void,
};

const Ads = ({ desktop, mobile, divId, onSlotRenderEnded }: Props) => {
  useEffect(() => {
    let adsId, sizes;
    const mobileView = !window.matchMedia('(min-width: 768px)').matches;

    if (mobileView) {
      ({ adsId, sizes } = mobile);
    } else {
      ({ adsId, sizes } = desktop);
    }

    if (!adsId || !sizes) {
      onSlotRenderEnded && onSlotRenderEnded({ isEmpty: true });
      return;
    }

    let eventHandler;
    let slot;

    window.googletag = window.googletag || { cmd: [] };
    googletag.cmd.push(function () {
      slot = googletag
        .defineSlot(adsId, sizes, divId)
        .addService(googletag.pubads());
      googletag.pubads().enableSingleRequest();
      googletag.pubads().collapseEmptyDivs();
      googletag.pubads().setForceSafeFrame(false);
      googletag.enableServices();
      eventHandler = function (event) {
        if (slot === event.slot) {
          onSlotRenderEnded && onSlotRenderEnded(event);
        }
      };
      googletag.pubads().addEventListener('slotRenderEnded', eventHandler);
      googletag.cmd.push(function () {
        googletag.display(divId);
      });
    });

    return () => {
      googletag.pubads().removeEventListener('slotRenderEnded', eventHandler);
      googletag.destroySlots([slot]);
    };
  }, []);

  return <div id={divId} className="ads-wrapper" />;
};

export default Ads;
